import './LoadMore.css';
import React from 'react';
import { styled } from 'linaria/lib/react';
var renderLoaderBar = function renderLoaderBar(loadedHits, nbHits) {
  if (loadedHits && nbHits && loadedHits > 0 && nbHits > 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "load-more__line"
    }, /*#__PURE__*/React.createElement("div", {
      className: "load-more__line-fill",
      style: {
        width: "".concat(loadedHits / nbHits * 100, "%")
      }
    }));
  }
};
var LoadMore = function LoadMore(_ref) {
  var buttonLabel = _ref.buttonLabel,
    _onClick = _ref.onClick,
    nbHits = _ref.nbHits,
    loadedHits = _ref.loadedHits,
    viewedNofMLabel = _ref.viewedNofMLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: "load-more ".concat(commonLoadMore)
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-light load-more__p"
  }, viewedNofMLabel.replace('{#loadedHits#}', String(loadedHits > nbHits ? nbHits : loadedHits)).replace('{#nbHits#}', String(nbHits))), /*#__PURE__*/React.createElement(LoadMoreButton, {
    className: "btn btn-secondary load-more__btn",
    onClick: function onClick(e) {
      _onClick();
      e.preventDefault();
    }
  }, buttonLabel));
};
var commonLoadMore = "cx0sqfq";
var LoadMoreButton = /*#__PURE__*/styled("button")({
  name: "LoadMoreButton",
  class: "l8vubv7"
});
export default LoadMore;